import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export interface EidsStatus {
    required: boolean;
    gsmVerified: boolean;
    profilePhonePresent: boolean;
    profilePhoneMasked: string | null;
    linked: boolean;
    verifiedName: string;
    firmaKoduConfigured: boolean;
    ssoUrl: string | null;
}

@Injectable({
    providedIn: 'root',
})
export class EidsService {
    constructor(private readonly apiService: ApiService) {}

    status(): Observable<EidsStatus> {
        return this.apiService.get<EidsStatus>('/api/eids/status');
    }

    requestOtp(): Observable<{ sent: boolean; profilePhoneMasked: string | null; devCode?: string }> {
        return this.apiService.post('/api/eids/otp', {});
    }

    verifyOtp(code: string): Observable<{ gsmVerified: boolean; profilePhoneMasked: string | null }> {
        return this.apiService.post('/api/eids/otp/verify', { code });
    }

    sso(): Observable<{ redirectUrl: string }> {
        return this.apiService.get('/api/eids/sso');
    }

    link(yetkiKodu: string, durum: string | null): Observable<{ linked: boolean; verifiedName: string }> {
        return this.apiService.post('/api/eids/link', { yetkiKodu, durum });
    }
}
